class ErrorHandler {
    constructor() {
        this.sentryModulePromise = null;
    }
    getSentry() {
        if (!this.sentryModulePromise) {
            this.sentryModulePromise = import(/* webpackChunkName: "sentry" */ "@sentry/vue");
        }
        return this.sentryModulePromise;
    }
    register(useSentry) {
        window.onerror = (message, source, lineno, colno, error) => {
            console.log('processing error');
            let details = {
                stackTrace: (error && (error.stackTrace || error.stack || null)),
                userAgent: navigator.userAgent || null,
                platform: navigator.platform || null,
                url: location.href || null,
                referrer: document.referrer || null,
                browserResolution: `${screen.width} x ${screen.height}`
            };
            if (!useSentry)
                return;
            this.getSentry()
                .then(Sentry => {
                try {
                    Sentry.captureException(details);
                }
                catch (ex) {
                    console.error(`Failed to submit error to Sentry: ${ex}`);
                }
            })
                .catch(ex => {
                console.error(`Failed to load Sentry module: ${ex}`);
            });
        };
    }
    ;
}
;
export default new ErrorHandler();
